<app-header></app-header>

<div class="container gift-card">
  <section class="gift-card__content">
    <div class="gift-card__intro">
      <span class="gift-card__eyebrow">{{ 'marketplace.gift-card.eyebrow' | transloco }}</span>
      <h1>{{ 'marketplace.gift-card.title' | transloco }}</h1>
      <p>{{ 'marketplace.gift-card.subtitle' | transloco }}</p>
    </div>

    <div class="gift-card__layout">
      <div class="gift-card__preview" aria-hidden="true">
        <div class="gift-card__card" appTilt>
          <div class="gift-card__card-noise"></div>
          <span class="gift-card__glare" data-tilt-glare aria-hidden="true"></span>
          <div class="gift-card__card-header">
            <div class="gift-card__brand">
              <div class="gift-card__logo-mark">
                <img src="assets/images/icon-512.png" alt="ShutterFlow"/>
              </div>
              <div class="gift-card__brand-text">ShutterFlow</div>
            </div>
            <span class="gift-card__card-tag">{{ 'marketplace.gift-card.preview.tag' | transloco }}</span>
          </div>

          <div class="gift-card__card-body">
            <p class="gift-card__card-label">{{ 'marketplace.gift-card.preview.amount' | transloco }}</p>
            <p class="gift-card__card-amount">
              {{ (form.value.amount || minAmount) + '€' }}
            </p>
            <p class="gift-card__card-to">
              {{ 'marketplace.gift-card.preview.to' | transloco }}
              {{ (form.value.recipientFirstName?.trim() || ('marketplace.gift-card.preview.recipient.placeholder' | transloco)) }}
            </p>
          </div>

          <div class="gift-card__card-footer">
            <div class="gift-card__card-from">
              <p class="gift-card__card-label">{{ 'marketplace.gift-card.preview.from' | transloco }}</p>
              <p class="gift-card__card-note">
                {{ (form.value.buyerFirstName?.trim() || ('marketplace.gift-card.preview.buyer.placeholder' | transloco)) }}
              </p>
            </div>
            <p class="gift-card__card-micro">{{ 'marketplace.gift-card.preview.secured' | transloco }}</p>
          </div>
        </div>
      </div>

      <form class="gift-card__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <div class="gift-card__form-header">
          <p class="gift-card__form-lead">{{ 'marketplace.gift-card.form.lead' | transloco }}</p>
          <div class="gift-card__badges">
            <span class="gift-card__badge">
              <i class="fa-solid fa-lock"></i>
            {{ 'marketplace.gift-card.form.badge.secure' | transloco }}
          </span>
          <span class="gift-card__badge">
            <i class="fa-solid fa-paper-plane"></i>
            {{ 'marketplace.gift-card.form.badge.delivery' | transloco }}
          </span>
        </div>
      </div>

      <div class="gift-card__section" [class.gift-card__section--collapsed]="!isSectionActive(0)">
        <button
          type="button"
          class="gift-card__section-header"
          [class.is-active]="isSectionActive(0)"
          [disabled]="!isSectionUnlocked(0)"
          (click)="openSection(0)"
          [attr.aria-expanded]="isSectionActive(0)"
        >
          <div class="gift-card__section-meta">
            <span class="gift-card__section-index">01</span>
            <div class="gift-card__section-title">
              <strong>{{ 'marketplace.gift-card.form.section.buyer' | transloco }}</strong>
              <span class="gift-card__section-state">
                {{ getSectionStatusLabel(0) | transloco }}
              </span>
            </div>
          </div>
          <i class="fa-solid" [ngClass]="{'fa-chevron-down': !isSectionActive(0), 'fa-chevron-up': isSectionActive(0)}"></i>
        </button>
        <div
          class="gift-card__section-body"
          [class.is-open]="isSectionActive(0)"
          [attr.aria-hidden]="!isSectionActive(0)"
        >
          <div class="gift-card__section-inner">
            <div class="gift-card__grid">
              <div class="input-group" [ngClass]="{'gift-card__field--invalid': showError('buyerFirstName')}">
                <label for="buyerFirstName">{{ 'marketplace.gift-card.form.buyer-first-name.label' | transloco }}</label>
                <input
                  id="buyerFirstName"
                  type="text"
                  formControlName="buyerFirstName"
                  autocomplete="given-name"
                  placeholder="{{ 'marketplace.gift-card.form.buyer-first-name.placeholder' | transloco }}"
                />
                <small *ngIf="showError('buyerFirstName')">
                  {{ 'marketplace.gift-card.form.buyer-first-name.error' | transloco }}
                </small>
                <small *ngIf="!showError('buyerFirstName')">
                  {{ 'marketplace.gift-card.form.buyer-first-name.helper' | transloco }}
                </small>
              </div>

              <div class="input-group" [ngClass]="{'gift-card__field--invalid': showError('buyerEmail')}">
                <label for="buyerEmail">{{ 'marketplace.gift-card.form.buyer.label' | transloco }}</label>
                <input
                  id="buyerEmail"
                  type="email"
                  formControlName="buyerEmail"
                  autocomplete="email"
                  placeholder="{{ 'marketplace.gift-card.form.buyer.placeholder' | transloco }}"
                />
                <small *ngIf="showError('buyerEmail')">
                  {{ 'marketplace.gift-card.form.buyer.error' | transloco }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gift-card__section" [class.gift-card__section--collapsed]="!isSectionActive(1)">
        <button
          type="button"
          class="gift-card__section-header"
          [class.is-active]="isSectionActive(1)"
          [disabled]="!isSectionUnlocked(1)"
          (click)="openSection(1)"
          [attr.aria-expanded]="isSectionActive(1)"
        >
          <div class="gift-card__section-meta">
            <span class="gift-card__section-index">02</span>
            <div class="gift-card__section-title">
              <strong>{{ 'marketplace.gift-card.form.section.recipient' | transloco }}</strong>
              <span class="gift-card__section-state">
                {{ getSectionStatusLabel(1) | transloco }}
              </span>
            </div>
          </div>
          <i class="fa-solid" [ngClass]="{'fa-chevron-down': !isSectionActive(1), 'fa-chevron-up': isSectionActive(1)}"></i>
        </button>
        <div
          class="gift-card__section-body"
          [class.is-open]="isSectionActive(1)"
          [attr.aria-hidden]="!isSectionActive(1)"
        >
          <div class="gift-card__section-inner">
            <div class="gift-card__grid">
              <div class="input-group" [ngClass]="{'gift-card__field--invalid': showError('recipientEmail')}">
                <label for="recipientEmail">{{ 'marketplace.gift-card.form.recipient.label' | transloco }}</label>
                <input
                  id="recipientEmail"
                  type="email"
                  formControlName="recipientEmail"
                  autocomplete="email"
                  placeholder="{{ 'marketplace.gift-card.form.recipient.placeholder' | transloco }}"
                />
                <small *ngIf="showError('recipientEmail')">
                  {{ 'marketplace.gift-card.form.recipient.error' | transloco }}
                </small>
              </div>

              <div class="input-group">
                <label for="recipientFirstName">{{ 'marketplace.gift-card.form.recipient-first-name.label' | transloco }}</label>
                <input
                  id="recipientFirstName"
                  type="text"
                  formControlName="recipientFirstName"
                  autocomplete="off"
                  placeholder="{{ 'marketplace.gift-card.form.recipient-first-name.placeholder' | transloco }}"
                />
                <small>{{ 'marketplace.gift-card.form.recipient-first-name.helper' | transloco }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gift-card__section" [class.gift-card__section--collapsed]="!isSectionActive(2)">
        <button
          type="button"
          class="gift-card__section-header"
          [class.is-active]="isSectionActive(2)"
          [disabled]="!isSectionUnlocked(2)"
          (click)="openSection(2)"
          [attr.aria-expanded]="isSectionActive(2)"
        >
          <div class="gift-card__section-meta">
            <span class="gift-card__section-index">03</span>
            <div class="gift-card__section-title">
              <strong>{{ 'marketplace.gift-card.form.section.delivery' | transloco }}</strong>
              <span class="gift-card__section-state">
                {{ getSectionStatusLabel(2) | transloco }}
              </span>
            </div>
          </div>
          <i class="fa-solid" [ngClass]="{'fa-chevron-down': !isSectionActive(2), 'fa-chevron-up': isSectionActive(2)}"></i>
        </button>
        <div
          class="gift-card__section-body"
          [class.is-open]="isSectionActive(2)"
          [attr.aria-hidden]="!isSectionActive(2)"
        >
          <div class="gift-card__section-inner">
            <div class="gift-card__grid">
              <div class="input-group">
                <label for="deliveryDate">{{ 'marketplace.gift-card.form.delivery.label' | transloco }}</label>
                <input
                  id="deliveryDate"
                  type="date"
                  formControlName="deliveryDate"
                  [attr.min]="todayIso"
                  placeholder="{{ 'marketplace.gift-card.form.delivery.placeholder' | transloco }}"
                />
                <small>{{ 'marketplace.gift-card.form.delivery.helper' | transloco }}</small>
              </div>

              <div class="input-group" [ngClass]="{'gift-card__field--invalid': showError('amount')}">
                <label for="amount">{{ 'marketplace.gift-card.form.amount.label' | transloco }}</label>
                <input
                  id="amount"
                  type="number"
                  inputmode="decimal"
                  formControlName="amount"
                  min="{{ minAmount }}"
                  max="{{ maxAmount }}"
                  step="{{ amountStep }}"
                />
                <small>
                  {{ 'marketplace.gift-card.form.amount.helper' | transloco:{min: minAmount, max: maxAmount, step: amountStep} }}
                </small>
              </div>
            </div>

            <div class="input-group gift-card__full-row">
              <label for="message">{{ 'marketplace.gift-card.form.message.label' | transloco }}</label>
              <textarea
                id="message"
                formControlName="message"
                rows="4"
                placeholder="{{ 'marketplace.gift-card.form.message.placeholder' | transloco }}"
              ></textarea>
              <small>{{ 'marketplace.gift-card.form.message.helper' | transloco }}</small>
            </div>
          </div>
        </div>
      </div>

      <div class="input-group gift-card__terms" [ngClass]="{'gift-card__field--invalid': showError('termsAccepted')}">
        <label for="termsAccepted">
          <input type="checkbox" id="termsAccepted" formControlName="termsAccepted" />
          <span>{{ 'marketplace.gift-card.form.terms.label' | transloco }}</span>
        </label>
        <small *ngIf="showError('termsAccepted')">
          {{ 'marketplace.gift-card.form.terms.error' | transloco }}
        </small>
      </div>

      <button type="submit" class="button button--primary gift-card__submit" [disabled]="isSubmitting">
        <span *ngIf="!isSubmitting">{{ 'marketplace.gift-card.form.submit' | transloco }}</span>
        <span *ngIf="isSubmitting">{{ 'marketplace.gift-card.form.submitting' | transloco }}</span>
      </button>
      </form>
    </div>
  </section>
</div>

<app-footer></app-footer>
